/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { authResetPassword } from '../../axios/authResetPassword'
import type {
	AuthResetPasswordError,
	AuthResetPasswordRequest,
	AuthResetPasswordResponse,
} from '../../types/AuthResetPassword'

export const authResetPasswordMutationKey = () => [{ url: '/auth/reset-password' }] as const

export type AuthResetPasswordMutationKey = ReturnType<typeof authResetPasswordMutationKey>

export type AuthResetPasswordVariables = {
	data: AuthResetPasswordRequest
}

/** @see backend/nexus/modules/Authentication/Http/Controllers/AuthController.php AuthController::resetPassword */
export function useAuthResetPassword<TContext = unknown>(
	options?: UseMutationOptions<
		AuthResetPasswordResponse,
		AxiosError<AuthResetPasswordError>,
		AuthResetPasswordVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: authResetPasswordMutationKey(),
		mutationFn: ({ data }: AuthResetPasswordVariables) => authResetPassword(data, config).then(res => res.data),
		...options,
	})
}
